import { useI18n } from '../i18n/useI18n';

interface FestivalFiltersProps {
  activeType: string;
  onChange: (type: string) => void;
}

export default function FestivalFilters({ activeType, onChange }: FestivalFiltersProps) {
  const { t } = useI18n();
  const filters = [
    { key: '', label: t('festival.all') },
    { key: 'public', label: t('festival.openToPublic') },
    { key: 'private', label: t('festival.privateRooms') },
    { key: 'both', label: t('festival.publicAndPrivate') },
  ];

  return (
    <nav className="festival-filters">
      <div className="festival-filters__scroll">
        {filters.map((f) => (
          <button
            key={f.key}
            type="button"
            className={`festival-filter ${activeType === f.key ? 'festival-filter--active' : ''}`}
            onClick={() => onChange(f.key)}
          >
            {f.label}
          </button>
        ))}
      </div>
    </nav>
  );
}
